import { SystemOptionType } from 'data/types';
import {
  AuxHeatCostLine,
  auxHeatCostLineForOption
} from 'utils/aux-heat-cost-line';

// The annual operating cost of a ductless option split the way the SQL
// computes it: the hours the heat pump carries on each side, plus the
// resistance heat priced for the heating hours it cannot carry. The total is
// the same whole-room figure the sort and value score read.
export type OperatingCostBreakdown = {
  coolingCost: number;
  heatingCost: number;
  auxHeat: AuxHeatCostLine | null;
  totalAnnualCost: number;
};

type OptionWithCostParts = SystemOptionType & {
  coolingCost?: number | null;
  heatingCost?: number | null;
};

const finite = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

// Null when the option does not carry the per-side figures (ducted
// compatibility options, options built before the parts were summed); the
// card then falls back to the single operating-cost row.
export function operatingCostBreakdownForOption(
  system: SystemOptionType
): OperatingCostBreakdown | null {
  const { coolingCost, heatingCost, totalAnnualCost } =
    system as OptionWithCostParts;
  if (
    !finite(coolingCost) ||
    !finite(heatingCost) ||
    !finite(totalAnnualCost)
  ) {
    return null;
  }
  return {
    coolingCost,
    heatingCost,
    auxHeat: auxHeatCostLineForOption(system),
    totalAnnualCost
  };
}
